
import { FormState__setValidationResponse_5219762A, FormState__startLoading, LabelConfiguration, FormState_get_empty, RequestedValue$1 } from "../../../Shared/Shared.js";
import { fileName as fileName_1, withTextLinesFor, defaultConfiguration, textLinesFor, resolveLines, Placeholder_code, sampleValues, sampleCodeFor, LabelInventoryKind } from "../../../Shared/Label.js";
import { Msg, State, PreviewSource as PreviewSource_3 } from "./Types.js";
import { Cmd_OfPromise_either, Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { getCustomerConfiguration } from "../../../Requests/Configuration.js";
import { deleteReservedCode, previewLabel, updateLabelConfiguration, getReservedCodes } from "../../../Requests/Labels.js";
import { ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { map, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { add, ofList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { comparePrimitives } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { downloadSingleLabel } from "../../../Labels/LabelPdf.js";

export const initialState = new State(new RequestedValue$1(0, []), undefined, false, new LabelInventoryKind(0, []), new PreviewSource_3(0, []), new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, Cmd_batch(ofArray([getCustomerConfiguration((Item) => (new Msg(0, [Item])), (Item_1) => (new Msg(18, [Item_1]))), getReservedCodes((Item_2) => (new Msg(15, [Item_2])), (Item_3) => (new Msg(18, [Item_3])))]))];
}

function draftSampleCode(state) {
    return defaultArg(map((draft) => sampleCodeFor(draft.CodePrefix), state.Draft), sampleCodeFor(""));
}

export function previewCode(state) {
    const matchValue = state.PreviewSource;
    if (matchValue.tag === 1) {
        return defaultArg(matchValue.fields[1].Code, draftSampleCode(state));
    }
    else {
        return draftSampleCode(state);
    }
}

export function previewValues(state) {
    let values;
    const matchValue = state.PreviewSource;
    values = ((matchValue.tag === 1) ? ofList(matchValue.fields[1].Values, {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }) : sampleValues(state.ActiveKind));
    return add(Placeholder_code, previewCode(state), values);
}

export function previewLines(state, configuration) {
    return resolveLines(previewValues(state), textLinesFor(state.ActiveKind, configuration.TextLines));
}

export function update(onConfigurationChanged, msg, state) {
    let FormState_4, matchValue_4, matchValue_5, draft_3, stored_1;
    switch (msg.tag) {
        case 1:
            return [new State(state.CustomerConfiguration, defaultConfiguration, true, state.ActiveKind, state.PreviewSource, state.ReservedCodes, state.FormState), Cmd_none()];
        case 2: {
            const matchValue = state.CustomerConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.CustomerConfiguration, matchValue.fields[0].LabelConfiguration, false, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState_get_empty()), Cmd_none()];
            }
        }
        case 3:
            return [new State(state.CustomerConfiguration, msg.fields[0], true, state.ActiveKind, state.PreviewSource, state.ReservedCodes, state.FormState), Cmd_none()];
        case 4:
            return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, msg.fields[0], new PreviewSource_3(0, []), state.ReservedCodes, state.FormState), Cmd_none()];
        case 5: {
            const matchValue_1 = state.Draft;
            if (matchValue_1 == null) {
                return [state, Cmd_none()];
            }
            else {
                const draft_1 = matchValue_1;
                return [new State(state.CustomerConfiguration, new LabelConfiguration(draft_1.WidthMm, draft_1.HeightMm, draft_1.MarginMm, draft_1.CodeType, draft_1.CodePosition, draft_1.ShowCodeValue, draft_1.ShowLogo, draft_1.CodePrefix, withTextLinesFor(msg.fields[0], msg.fields[1], draft_1.TextLines), draft_1.Enabled), true, state.ActiveKind, state.PreviewSource, state.ReservedCodes, state.FormState), Cmd_none()];
            }
        }
        case 6: {
            const matchValue_2 = state.Draft;
            if (matchValue_2 == null) {
                return [state, Cmd_none()];
            }
            else {
                const draft_2 = matchValue_2;
                return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState__startLoading(state.FormState)), updateLabelConfiguration(draft_2, (Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(18, [Item_1])))];
            }
        }
        case 7:
            if (msg.fields[0].tag === 1) {
                return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(new RequestedValue$1(1, [msg.fields[0].fields[0]]), msg.fields[0].fields[0].LabelConfiguration, false, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg) => {
                    onConfigurationChanged();
                })]))];
            }
        case 8: {
            const matchValue_3 = state.CustomerConfiguration;
            let matchResult, stored;
            if (matchValue_3.tag === 1) {
                if (matchValue_3.fields[0].LabelConfiguration != null) {
                    matchResult = 0;
                    stored = matchValue_3.fields[0].LabelConfiguration;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState__startLoading(state.FormState)), updateLabelConfiguration(new LabelConfiguration(stored.WidthMm, stored.HeightMm, stored.MarginMm, stored.CodeType, stored.CodePosition, stored.ShowCodeValue, stored.ShowLogo, stored.CodePrefix, stored.TextLines, msg.fields[0]), (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(18, [Item_3])))];
                default:
                    return [state, Cmd_none()];
            }
        }
        case 9:
            if (msg.fields[0].tag === 1) {
                return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[0].fields[0])), Cmd_errorToast("validation.toast")];
            }
            else {
                return [(FormState_4 = FormState_get_empty(), new State(new RequestedValue$1(1, [msg.fields[0].fields[0]]), (matchValue_4 = state.Draft, (matchValue_5 = msg.fields[0].fields[0].LabelConfiguration, (matchValue_4 != null) ? ((matchValue_5 != null) ? ((draft_3 = matchValue_4, (stored_1 = matchValue_5, new LabelConfiguration(draft_3.WidthMm, draft_3.HeightMm, draft_3.MarginMm, draft_3.CodeType, draft_3.CodePosition, draft_3.ShowCodeValue, draft_3.ShowLogo, draft_3.CodePrefix, draft_3.TextLines, stored_1.Enabled)))) : matchValue_5) : matchValue_5)), state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState_4)), Cmd_batch(ofArray([Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    onConfigurationChanged();
                })]))];
            }
        case 10:
            return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState__startLoading(state.FormState)), previewLabel(msg.fields[0], (response) => (new Msg(11, [msg.fields[0], response])), (Item_4) => (new Msg(18, [Item_4])))];
        case 11:
            if (msg.fields[1].tag === 1) {
                return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState__setValidationResponse_5219762A(state.FormState, msg.fields[1].fields[0])), Cmd_none()];
            }
            else {
                return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, new PreviewSource_3(1, [msg.fields[0], msg.fields[1].fields[0]]), state.ReservedCodes, FormState_get_empty()), Cmd_none()];
            }
        case 12:
            return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, new PreviewSource_3(0, []), state.ReservedCodes, state.FormState), Cmd_none()];
        case 13: {
            const matchValue_7 = state.Draft;
            const matchValue_8 = state.CustomerConfiguration;
            let matchResult_1, configuration_4, draft_4;
            if (matchValue_7 != null) {
                if (matchValue_8.tag === 1) {
                    matchResult_1 = 0;
                    configuration_4 = matchValue_8.fields[0];
                    draft_4 = matchValue_7;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const code = previewCode(state);
                    const fileName = fileName_1(code, undefined);
                    return [state, Cmd_OfPromise_either(() => downloadSingleLabel(draft_4, code, previewLines(state, draft_4), configuration_4.AppLogoConfiguration.WideLogoUrl, fileName), undefined, () => (new Msg(14, [undefined])), (Item_6) => (new Msg(18, [Item_6])))];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 14:
            return [state, Cmd_none()];
        case 15:
            return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
        case 16:
            return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState__startLoading(state.FormState)), deleteReservedCode(msg.fields[0], (Item_7) => (new Msg(17, [Item_7])), (Item_8) => (new Msg(18, [Item_8])))];
        case 17:
            return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("labels.settings.reserved_code_deleted"), getReservedCodes((Item_9) => (new Msg(15, [Item_9])), (Item_10) => (new Msg(18, [Item_10])))]))];
        case 18:
            return [new State(state.CustomerConfiguration, state.Draft, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, FormState_get_empty()), Cmd_errorToast("general.a_error_occured")];
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.IsDirty ? state.Draft : msg.fields[0].LabelConfiguration, state.IsDirty, state.ActiveKind, state.PreviewSource, state.ReservedCodes, state.FormState), Cmd_none()];
    }
}

